import { render, staticRenderFns } from "./showSalse.vue?vue&type=template&id=68e71a92&scoped=true&"
import script from "./showSalse.vue?vue&type=script&lang=js&"
export * from "./showSalse.vue?vue&type=script&lang=js&"
import style0 from "./showSalse.vue?vue&type=style&index=0&id=68e71a92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e71a92",
  null
  
)

export default component.exports